import React, { SVGProps } from 'react';

const IndicatorWarning: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M0 10.5C0 16.299 4.70101 21 10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5ZM20 10.5C20 15.7467 15.7467 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1C15.7467 1 20 5.25329 20 10.5ZM11 10.5C11 10.7761 10.7761 11 10.5 11C10.2239 11 10 10.7761 10 10.5V6.5C10 6.22386 10.2239 6 10.5 6C10.7761 6 11 6.22386 11 6.5V10.5ZM11 14V13H10V14H11Z" fill="#F8BF2D" />
  </svg>
);

export default IndicatorWarning;
